import { ICreateAndUpdateSuperAgentProvince } from "../../../types/superAgent.interface";
import customAxios from "../../customAxios";
import { UPDATE_SUPER_AGENT_PROVINCE } from "../../routes";

const updateSuperAgentProvince = async (
  formData: ICreateAndUpdateSuperAgentProvince
) => {
  try {
    return (
      await customAxios.put(UPDATE_SUPER_AGENT_PROVINCE + `/${formData._id}`, {
        phoneNumber: formData.phoneNumber,
        name: formData.name,
        province: formData.province?._id,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ UPDATE_SUPER_AGENT_PROVINCE: error });
    return false;
  }
};

export default updateSuperAgentProvince;
